import { supabase } from "@/integrations/supabase/client";

/** URLs assinadas para exibir imagens MinIO no browser (bucket privado). */
export async function resolveProductImageDisplayUrls(
  workspaceId: string,
  productId: string,
  imageIds?: string[],
): Promise<Record<string, string>> {
  const { data, error } = await supabase.functions.invoke("resolve-product-image-urls", {
    body: {
      workspace_id: workspaceId,
      product_id: productId,
      ...(imageIds && imageIds.length > 0 ? { image_ids: imageIds } : {}),
    },
  });

  if (error) {
    console.warn("[product-image-display] resolve failed:", error);
    return {};
  }

  const images = (data as { images?: Array<{ id: string; url?: string }> } | null)?.images ?? [];
  const map: Record<string, string> = {};
  for (const row of images) {
    if (row.id && row.url) map[row.id] = row.url;
  }
  return map;
}

export function productImageDisplaySrc(
  img: { id: string; public_url: string; isExternal?: boolean },
  displayUrls: Record<string, string>,
): string {
  if (img.isExternal) return img.public_url;
  return displayUrls[img.id] || img.public_url;
}
